<template>
  <v-card v-if="isEnabled" class="success-feedback">
    <hr class="success my-4 mx-2" />

    <v-card-title class="text-center headline mx-auto">
      {{ $t('success.feedback.title') }}
    </v-card-title>

    <v-card-text class="mx-4">
      {{ $t('success.feedback.text') }}
    </v-card-text>

    <v-card-text class="mx-4" v-html="$t('success.feedback.textSecond')" />

    <v-card-actions class="feedback-button-container">
      <v-btn
        data-cy="success-view-feedback-participate-btn"
        color="success"
        class="mb-4"
        @click="showFeedbackForm"
      >
        {{ $t('success.feedback.confirm') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'FeedbackBanner',
  data() {
    return {
      isEnabled: true, // Make it false to disable the banner
    };
  },
  methods: {
    showFeedbackForm() {
      window.open(this.$t('feedback.feedbackLink'), '_blank');
    },
  },
};
</script>

<style scoped>
.success-feedback {
  width: 100%;
}

.feedback-button-container {
  display: flex;
  justify-content: flex-end;
  margin: 0 16px 16px;
}
</style>
